module.exports = __webpack_public_path__ + "img/event_decarbonation.a048eff7.png";